"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueSourceCandidatesRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
/**
 * Bounding-box search against Overture / OSM for admin venue creation.
 * Does not persist anything — results are for form prefill only.
 */
class VenueSourceCandidatesRequestDto {}
exports.VenueSourceCandidatesRequestDto = VenueSourceCandidatesRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Southwest corner latitude (WGS84)'
}), __metadata("design:type", String)], VenueSourceCandidatesRequestDto.prototype, "southwestLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Southwest corner longitude (WGS84)'
}), __metadata("design:type", String)], VenueSourceCandidatesRequestDto.prototype, "southwestLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Northeast corner latitude (WGS84)'
}), __metadata("design:type", String)], VenueSourceCandidatesRequestDto.prototype, "northeastLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Northeast corner longitude (WGS84)'
}), __metadata("design:type", String)], VenueSourceCandidatesRequestDto.prototype, "northeastLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Optional case-insensitive name filter applied after fetch'
}), __metadata("design:type", String)], VenueSourceCandidatesRequestDto.prototype, "searchTerms", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  default: true
}), __metadata("design:type", Boolean)], VenueSourceCandidatesRequestDto.prototype, "includeOverture", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  default: true
}), __metadata("design:type", Boolean)], VenueSourceCandidatesRequestDto.prototype, "includeOsm", void 0);
//# sourceMappingURL=VenueSourceCandidatesRequest.dto.js.map